export default __webpack_public_path__ + "static/media/gameI-mobile-intro1.0ee4c40a.png";